import { render } from "./Appendix.vue?vue&type=template&id=59ba9580"
import script from "./Appendix.vue?vue&type=script&lang=js"
export * from "./Appendix.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__